import Connector from './connector';
import { EntityDetailsBalanceSheet as Component } from './EntityDetailsBalanceSheet';

const EntityDetailsBalanceSheet = () => <Connector component={Component} />;

export default EntityDetailsBalanceSheet;
